export default {
      id: "help-bubble-usage",
      viewBox: "0 0 69 60",
      url: "/" + "sprite.svg#help-bubble",
      toString: function () {
        return this.url;
      }
    }